// get positive and negative sign of a number
export const getSign = (num) => {
    if (num > 0)
        return 1;
    if (num < 0)
        return -1;
    if (num === 0)
        return 0;
    return NaN;
};
//# sourceMappingURL=util.js.map